import React from "react";
import "./AlertPopup.scss";
import Alert from "@material-ui/lab/Alert";
import Collapse from "@material-ui/core/Collapse";

export default function AlertPopup({ message, open }) {
  return (
      <div className={open ? "alert --open" : "alert"}>
        <Alert severity="error">{message}</Alert>
      </div>
  );
}
